import { buildAuthorizeUrl, createPkceChallenge, stashPkce } from '@insightai/auth'
import { config, consoleCallbackUri } from '../config'
import { mockSignIn } from './mockAuth'

/**
 * Starts the PKCE flow from a marketing auth screen.
 *
 * The marketing app never holds a token. It generates the challenge, stashes the
 * verifier, and redirects to Keycloak with the console's callback as the redirect
 * URI — the console completes the exchange and owns the session (SEC-FR-001).
 *
 * `identityProviderHint` sends the user straight to Google or Microsoft (M00-16)
 * rather than through an intermediate IdP chooser.
 *
 * THIS IS THE CHOKE POINT FOR THE PROTOTYPE BYPASS. Login, signup and both social
 * buttons all reach the IdP through this one function, so prototype mode needs a
 * single branch here rather than a bypass in each of the four callers. The real
 * path below is left exactly as it was: turning `VITE_MOCK_API=false` restores it
 * with no other change.
 */
export async function startPkce(options?: {
  loginHint?: string
  password?: string
  identityProvider?: 'google' | 'microsoft'
  /** Keycloak registration screen for the social-signup path. */
  register?: boolean
  locale?: string
}) {
  if (config.prototypeMode) {
    const { redirectTo } = await mockSignIn({
      email: options?.loginHint,
      password: options?.password,
      provider: options?.identityProvider,
      register: options?.register,
    })
    window.location.assign(redirectTo)
    return
  }

  const challenge = await createPkceChallenge()
  stashPkce(challenge)

  const endpoint = options?.register
    ? config.keycloak.authorizationEndpoint.replace('/auth', '/registrations')
    : config.keycloak.authorizationEndpoint

  window.location.assign(
    buildAuthorizeUrl({
      authorizationEndpoint: endpoint,
      clientId: config.keycloak.clientId,
      redirectUri: consoleCallbackUri,
      challenge,
      loginHint: options?.loginHint,
      identityProviderHint: options?.identityProvider,
      locale: options?.locale,
    }),
  )
}
